export enum EParamsId {
  GOOGLE = "6d279330-cf59-407a-85e9-74e7292e8c13",
  CLIENT_NAME = "c3007c4d-0c72-457d-ac11-a6f8c42ca979",
  THEME = "0eb9d196-b277-4754-93cc-6b9a834effeb",
  PROGRAMATION_SOLICITATION_MIN_DAYS = "b74f37ea-fcf7-4309-9929-96b1b955d623",
  LOGIN_COLOR = "1d4c845a-bce9-417a-8480-c930853f0597"
}